
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tAfoWaveDetail/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tAfoWaveDetail/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tAfoWaveDetail/findPage',
        method: 'post',
      data
    })
}

// 从波次移除订单
export const removeOrder = (data) => {
  return axios({
    url: '/tAfoWaveDetail/removeOrder',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/tAfoWaveDetail.js